import { useEffect, useState } from "react";
import { MessageCircle, Phone, ArrowUp } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function StickyButtons() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <a
        href={`https://wa.me/${COMPANY.whatsapp}?text=Hello%20Advance%20HR%20Technologies%2C%20I%27d%20like%20to%20discuss%20a%20requirement.`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-emerald-600/30 flex items-center justify-center hover:scale-105 transition-transform"
        aria-label="WhatsApp us"
      >
        <MessageCircle className="w-6 h-6" strokeWidth={2} />
      </a>

      <a
        href={`tel:${COMPANY.phoneRaw}`}
        data-testid="sticky-call"
        className="fixed bottom-6 left-6 z-40 lg:hidden w-14 h-14 rounded-full bg-primary text-white shadow-lg shadow-primary/30 flex items-center justify-center hover:scale-105 transition-transform"
        aria-label="Call us"
      >
        <Phone className="w-5 h-5" strokeWidth={2} />
      </a>

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="scroll-to-top"
          className="fixed bottom-24 right-6 z-40 w-11 h-11 rounded-full bg-slate-900 text-white shadow-lg hover:bg-primary transition-colors flex items-center justify-center"
          aria-label="Scroll to top"
        >
          <ArrowUp className="w-4 h-4" strokeWidth={2} />
        </button>
      )}
    </>
  );
}
